module.exports = __webpack_public_path__ + "img/2.1e494368.jpg";